<mbs-modal
  [isCustomModal]="true"
  [title]="title">
  <ng-container
    modal-body
    [formGroup]="form">
    <mbs-form-group>
      <ng-container *ngTemplateOutlet="frequency"></ng-container>
      <ng-container *ngTemplateOutlet="presets"></ng-container>
      <ng-container *ngTemplateOutlet="days"></ng-container>
      <ng-container *ngTemplateOutlet="occurrence"></ng-container>
      <ng-container *ngTemplateOutlet="calendarDay"></ng-container>
      <ng-container *ngTemplateOutlet="daysSelect"></ng-container>
      <ng-container *ngTemplateOutlet="time"></ng-container>
      <ng-container *ngTemplateOutlet="repeat"></ng-container>
      <ng-container *ngTemplateOutlet="synthetic"></ng-container>

      <ng-template #frequency>
        <div class="row">
          <div class="col-4">{{ 'wizards:schedule.scheduleModal.backupFrequency.title' | i18next }}:</div>
          <div class="col-8 ml-n5">
            <div class="d-flex align-items-center">
              <mbs-radio
                formControlName="recurringPeriod"
                name="recurringPeriod"
                value="Daily"
                [id]="elementSelectors.id.dailyRadio"
                [label]="'wizards:schedule.scheduleModal.backupFrequency.daily' | i18next"
                (change)="setFrequency('Daily')"></mbs-radio>
              <mbs-radio
                class="mt-0 ml-3"
                formControlName="recurringPeriod"
                name="recurringPeriod"
                value="Monthly"
                [id]="elementSelectors.id.monthlyRadio"
                [label]="'wizards:schedule.scheduleModal.backupFrequency.monthly' | i18next"
                (change)="setFrequency('Monthly')"></mbs-radio>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template #presets>
        <div
          *ngIf="isDaily"
          class="row mt-4"
          [id]="elementSelectors.id.presetsBlock">
          <div class="col-4">{{ 'wizards:schedule.scheduleModal.recommendedPresets.title' | i18next }}:</div>
          <div class="col-8 ml-n5 mt-n1">
            <div class="d-flex align-items-center">
              <mbs-button
                [id]="elementSelectors.id.presetWeekdaysButton"
                [rounded]="true"
                [type]="!!preset.weekdays ? 'primary' : 'outline-primary'"
                (click)="setPreset('weekdays')">
                {{ 'wizards:schedule.scheduleModal.recommendedPresets.weekdays' | i18next }}
              </mbs-button>
              <mbs-button
                class="ml-2"
                [id]="elementSelectors.id.presetEverydayButton"
                [rounded]="true"
                [type]="!!preset.everyday ? 'primary' : 'outline-primary'"
                (click)="setPreset('everyday')">
                {{ 'wizards:schedule.scheduleModal.recommendedPresets.everyday' | i18next }}
              </mbs-button>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template #days>
        <div
          *ngIf="isDaily"
          class="row mt-4"
          [id]="elementSelectors.id.daysBlock">
          <div class="col-4">{{ 'wizards:schedule.scheduleModal.days.title' | i18next }}:</div>
          <div class="col-8 ml-n5 mt-n1">
            <mbs-group-button
              class="d-flex align-items-center"
              [toggle]="false">
              <mbs-button
                *ngFor="let day of week; let i = index"
                [id]="elementSelectors.id.dayId(i)"
                [type]="!!day ? 'primary' : 'outline-primary'"
                (click)="setDay(i)">
                {{ daysShort[i] }}
              </mbs-button>
            </mbs-group-button>
          </div>
        </div>
      </ng-template>

      <ng-template #occurrence>
        <div
          *ngIf="isMonthly"
          class="row mt-4"
          [id]="elementSelectors.id.occurrenceBlock">
          <div class="col-4">
            {{ 'wizards:schedule.scheduleModal.occurrence.title' | i18next }}:
            <span
              class="fa fa-info-circle ml-2 cursor-help text-info"
              container="body"
              tooltipClass="tooltip-xl text-start"
              [ngbTooltip]="occurrenceTooltip"
              [placement]="'right'"></span>
            <ng-template #occurrenceTooltip>
              <div>
                <strong>{{ 'wizards:schedule.scheduleModal.occurrence.tooltip.DOM' | i18next }}: </strong>
                <span>{{ 'wizards:schedule.scheduleModal.occurrence.tooltip.DOMInfo' | i18next }}</span>
              </div>
              <div>
                <strong>{{ 'wizards:schedule.scheduleModal.occurrence.tooltip.FSTF' | i18next }}: </strong>
                <span>{{ 'wizards:schedule.scheduleModal.occurrence.tooltip.FSTFInfo' | i18next }}</span>
              </div>
              <div>
                <strong>{{ 'wizards:schedule.scheduleModal.occurrence.tooltip.PL' | i18next }}: </strong>
                <span>{{ 'wizards:schedule.scheduleModal.occurrence.tooltip.PLInfo' | i18next }}</span>
              </div>
            </ng-template>
          </div>
          <div class="col-3 ml-n5 mt-n1">
            <mbs-select
              formControlName="occurrence"
              [appendTo]="'.modal-content'"
              [bindLabel]="'label'"
              [bindValue]="'value'"
              [clearable]="false"
              [id]="elementSelectors.id.occurrenceSelect"
              [items]="weekNumberEnumArray"
              [searchable]="false"></mbs-select>
          </div>
        </div>
      </ng-template>

      <ng-template #calendarDay>
        <div
          *ngIf="isMonthly && isDayOfMonth"
          class="row mt-4"
          [id]="elementSelectors.id.calendarDayBlock">
          <div class="col-4">{{ 'wizards:schedule.scheduleModal.calendarDay.title' | i18next }}:</div>
          <div class="col-3 ml-n5 mt-n">
            <mbs-number
              formControlName="dayOfMonthCount"
              [max]="31"
              [min]="1"></mbs-number>
          </div>
        </div>
      </ng-template>

      <ng-template #daysSelect>
        <div
          *ngIf="isMonthly && isCountableDayOfMonth"
          class="row mt-4"
          [id]="elementSelectors.id.daysSelectBlock">
          <div class="col-4">{{ 'wizards:schedule.scheduleModal.daysSelect.title' | i18next }}:</div>
          <div class="col-3 ml-n5 mt-n1">
            <mbs-select
              formControlName="dayOfWeek"
              [appendTo]="'.modal-content'"
              [bindLabel]="'label'"
              [bindValue]="'value'"
              [clearable]="false"
              [items]="daysOfWeekEnumArray"
              [searchable]="false"></mbs-select>
          </div>
        </div>
      </ng-template>

      <ng-template #time>
        <div class="row mt-4">
          <div class="col-4">
            {{ 'wizards:schedule.scheduleModal.time.title' | i18next }}:
            <span
              *ngIf="isFullEqualIncremental"
              class="fa fa-info-circle ml-2 cursor-help text-info"
              container="body"
              tooltipClass="tooltip-lg"
              [id]="elementSelectors.id.timeTooltip"
              [ngbTooltip]="timeTooltip"
              [placement]="'right'"></span>
            <ng-template #timeTooltip>
              {{ 'wizards:schedule.scheduleModal.time.tooltip' | i18next }}
            </ng-template>
          </div>
          <div class="col-8 ml-n5">
            <div
              *ngIf="!isFull && isDaily"
              class="d-flex align-items-center"
              [id]="elementSelectors.id.timeRadioBlock">
              <mbs-radio
                class="mb-2"
                formControlName="dailyFreqPeriodOption"
                value="OccursAt"
                [id]="elementSelectors.id.timeSpecificRadio"
                [label]="'wizards:schedule.scheduleModal.time.specificTime' | i18next"
                (change)="dailyPeriodChangeHandler($event)"></mbs-radio>
              <mbs-radio
                class="mt-0 ml-3 mb-2"
                formControlName="dailyFreqPeriodOption"
                value="OccursEvery"
                [id]="elementSelectors.id.timeSeveralRadio"
                [label]="'wizards:schedule.scheduleModal.time.severalTime' | i18next"
                (change)="dailyPeriodChangeHandler($event)"></mbs-radio>
            </div>
            <div
              *ngIf="isSpecificTime"
              class="row"
              [id]="elementSelectors.id.timeSpecificBlock">
              <div class="col-4">
                <mbs-timepicker
                  formControlName="occursAtTime"
                  [id]="elementSelectors.id.timeSpecificTimepicker"
                  [meridian]="true"
                  [needChangeInvalid]="true"></mbs-timepicker>
              </div>
            </div>
            <div
              *ngIf="!isSpecificTime"
              class="row"
              [id]="elementSelectors.id.timeSeveralBlock1">
              <div class="col-1 mr-1">
                <mbs-input-label
                  class="mbs-form_label mb-0"
                  [label]="'wizards:schedule.scheduleModal.time.every' | i18next"></mbs-input-label>
              </div>
              <div class="col-3 mt-n1">
                <mbs-number
                  formControlName="occursEveryCount"
                  [id]="elementSelectors.id.timeSeveralEveryNumber"
                  [max]="form.get('occursEveryPeriod').value === 'hours' ? 23 : 1439"
                  [min]="1"></mbs-number>
              </div>
              <div class="col-3 mt-n1">
                <mbs-select
                  formControlName="occursEveryPeriod"
                  [bindLabel]="'label'"
                  [bindValue]="'value'"
                  [clearable]="false"
                  [id]="elementSelectors.id.timeSeveralPeriod"
                  [items]="hoursOrMinutesItems"
                  [searchable]="false"></mbs-select>
              </div>
            </div>
            <div
              *ngIf="!isSpecificTime"
              class="row mt-2"
              [id]="elementSelectors.id.timeSeveralBlock2">
              <div class="col-1 mr-1">
                <mbs-input-label
                  class="mbs-form_label mb-0"
                  [label]="'wizards:schedule.scheduleModal.time.from' | i18next"></mbs-input-label>
              </div>
              <div class="col-4 mt-n1">
                <mbs-timepicker
                  formControlName="occursEveryFromTime"
                  [id]="elementSelectors.id.timeSeveralTime1"
                  [meridian]="true"
                  [needChangeInvalid]="true"></mbs-timepicker>
              </div>
              <div class="col-auto pl-0">
                <mbs-input-label
                  class="mbs-form_label mb-0"
                  [label]="'wizards:schedule.scheduleModal.time.to' | i18next"></mbs-input-label>
              </div>
              <div class="col-4 mt-n1">
                <mbs-timepicker
                  formControlName="occursEveryToTime"
                  [id]="elementSelectors.id.timeSeveralTime2"
                  [meridian]="true"
                  [needChangeInvalid]="true"></mbs-timepicker>
              </div>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template #repeat>
        <div class="row mt-4">
          <div class="col-4">{{ 'wizards:schedule.scheduleModal.repeat.title' | i18next }}:</div>
          <div class="col-3 ml-n5 mt-n1">
            <mbs-number
              formControlName="repeatEveryCount"
              [id]="elementSelectors.id.repeatEveryNumber"
              [max]="31"
              [min]="1"></mbs-number>
          </div>
          <div
            *ngIf="!isMonthly"
            class="col-auto"
            [id]="elementSelectors.id.repeatEveryWeeks">
            {{ 'wizards:schedule.scheduleModal.repeat.weeks' | i18next }}
          </div>
          <div
            *ngIf="isMonthly"
            class="col-auto"
            [id]="elementSelectors.id.repeatEveryMonths">
            {{ 'wizards:schedule.scheduleModal.repeat.months' | i18next }}
          </div>
        </div>
      </ng-template>

      <ng-template #synthetic>
        <div
          *ngIf="isSimple && showSynthetic"
          class="mt-5 pt-4 border-top"
          [id]="elementSelectors.id.syntheticSection">
          <h5 class="mb-1">{{ 'wizards:schedule.scheduleModal.synthetic.title' | i18next }}</h5>
          <div class="mb-3 text-muted text-sm">{{ 'wizards:schedule.scheduleModal.synthetic.description' | i18next }}</div>

          <div
            *ngIf="!canSynthetic"
            [id]="elementSelectors.id.syntheticUnavailableBlock">
            <div class="mb-2 text-muted text-sm">{{ 'wizards:schedule.scheduleModal.synthetic.unavailable' | i18next }}</div>
            <mbs-beta-feature-request
              [buildName]="betaFeatureBtnData.backupBuilds"
              [featureName]="betaFeatureBtnData.syntheticFull"
              [version]="syntheticVersion"></mbs-beta-feature-request>
          </div>

          <div
            *ngIf="canSynthetic && !isDaily"
            class="text-muted text-sm"
            [id]="elementSelectors.id.syntheticMonthlyNote">
            {{ 'wizards:schedule.scheduleModal.synthetic.monthlyNote' | i18next }}
          </div>

          <div
            *ngIf="canSynthetic && isDaily"
            formGroupName="syntheticData"
            [id]="elementSelectors.id.syntheticScheduleBlock">
            <div class="row">
              <div class="col-4">{{ 'wizards:frequency_label' | i18next }}:</div>
              <div class="col-8 ml-n5">
                <div class="d-flex align-items-center">
                  <mbs-radio
                    formControlName="recurringPeriod"
                    name="syntheticRecurringPeriod"
                    value="Weekly"
                    [id]="elementSelectors.id.syntheticWeeklyRadio"
                    [label]="'wizards:schedule.scheduleModal.synthetic.weekly' | i18next"></mbs-radio>
                  <mbs-radio
                    class="mt-0 ml-3"
                    formControlName="recurringPeriod"
                    name="syntheticRecurringPeriod"
                    value="Monthly"
                    [id]="elementSelectors.id.syntheticMonthlyRadio"
                    [label]="'wizards:schedule.scheduleModal.synthetic.monthly' | i18next"></mbs-radio>
                </div>
              </div>
            </div>

            <div
              *ngIf="isSyntheticMonthly"
              class="row mt-4"
              [id]="elementSelectors.id.syntheticOccurrenceBlock">
              <div class="col-4">{{ 'wizards:schedule.scheduleModal.occurrence.title' | i18next }}:</div>
              <div class="col-3 ml-n5 mt-n1">
                <mbs-select
                  formControlName="occurrence"
                  [appendTo]="'.modal-content'"
                  [bindLabel]="'label'"
                  [bindValue]="'value'"
                  [clearable]="false"
                  [id]="elementSelectors.id.syntheticOccurrenceSelect"
                  [items]="syntheticWeekNumberEnumArray"
                  [searchable]="false"></mbs-select>
              </div>
            </div>

            <div
              class="row mt-4"
              [id]="elementSelectors.id.syntheticDayOfWeekBlock">
              <div class="col-4">{{ 'wizards:schedule.scheduleModal.daysSelect.title' | i18next }}:</div>
              <div class="col-3 ml-n5 mt-n1">
                <mbs-select
                  formControlName="dayOfWeek"
                  [appendTo]="'.modal-content'"
                  [bindLabel]="'label'"
                  [bindValue]="'value'"
                  [clearable]="false"
                  [id]="elementSelectors.id.syntheticDaySelect"
                  [items]="daysOfWeekEnumArray"
                  [searchable]="false"></mbs-select>
              </div>
            </div>

            <mbs-checkbox
              class="d-block mt-4"
              formControlName="runMissed"
              [id]="elementSelectors.id.syntheticRunMissedCheckbox"
              [label]="'wizards:schedule.scheduleModal.synthetic.runMissed' | i18next"></mbs-checkbox>
            <div class="ml-4 pl-2 text-muted text-sm">
              {{ 'wizards:schedule.scheduleModal.synthetic.runMissedDescription' | i18next }}
            </div>
          </div>
        </div>
      </ng-template>
    </mbs-form-group>
  </ng-container>

  <ng-container modalFooter>
    <button
      class="btn btn-primary"
      type="button"
      [attr.data-e2e]="elementSelectors.id.saveButton"
      [disabled]="form.invalid"
      (click)="saveClickHandler()">
      {{ 'shared:buttons.save' | i18next: { format: 'title' } }}
    </button>
    <button
      class="btn btn-secondary"
      data-dismiss="modal"
      type="button"
      [attr.data-e2e]="elementSelectors.id.cancelButton"
      (click)="cancelClickHandler()">
      {{ 'shared:buttons.cancel' | i18next: { format: 'title' } }}
    </button>
  </ng-container>
</mbs-modal>
